import React, { useEffect } from "react";
import helmetSrc from "../../assets/img/helmetScout.png";
import FavouriteReportsCard from "../../components/FavouriteReports/FavouriteReportsCard";
import { ReportsHeader } from "../ScoutingReports/ScoutingReports.styles";
import UploadReports from "../../components/ScoutingReports/UploadReports";
import { useDispatch, useSelector } from "react-redux";
import { fetchMyGuysReports } from "../../app/features/scoutingReports/reportAction";
import { selectUser } from "../../app/features/user/userSlice";

const favouriteReportsCardData = [
  {
    imageUrl: helmetSrc,
    tag: "QB",
    school: "Georgia",
    position: "QB",
    goals: "10",
    assists: "5",
    minutes: "90",
    cups: "4",
    playerName: "John Doe",
  },
  {
    imageUrl: helmetSrc,
    tag: "QB",
    school: "Georgia",
    position: "QB",
    goals: "10",
    assists: "5",
    minutes: "90",
    cups: "4",
    playerName: "John Doe",
  },
  {
    imageUrl: helmetSrc,
    tag: "QB",
    school: "Georgia",
    position: "QB",
    goals: "10",
    assists: "5",
    minutes: "90",
    cups: "4",
    playerName: "John Doe",
  },
  {
    imageUrl: helmetSrc,
    tag: "QB",
    school: "Georgia",
    position: "QB",
    goals: "10",
    assists: "5",
    minutes: "90",
    cups: "4",
    playerName: "John Doe",
  },
  {
    imageUrl: helmetSrc,
    tag: "QB",
    school: "Georgia",
    position: "QB",
    goals: "10",
    assists: "5",
    minutes: "90",
    cups: "4",
    playerName: "John Doe",
  },
  {
    imageUrl: helmetSrc,
    tag: "QB",
    school: "Georgia",
    position: "QB",
    goals: "10",
    assists: "5",
    minutes: "90",
    cups: "4",
    playerName: "John Doe",
  },
  {
    imageUrl: helmetSrc,
    tag: "QB",
    school: "Georgia",
    position: "QB",
    goals: "10",
    assists: "5",
    minutes: "90",
    cups: "4",
    playerName: "John Doe",
  },
  {
    imageUrl: helmetSrc,
    tag: "QB",
    school: "Georgia",
    position: "QB",
    goals: "10",
    assists: "5",
    minutes: "90",
    cups: "4",
    playerName: "John Doe",
  },
];

const MyGuys = () => {
  const { myGuysReports, myGuysReportsLoading, myGuysReportsSuccess, myGuysReportsError } = useSelector(
    (state) => state.scoutingReports
  );
  const dispatch = useDispatch();
  const { userToken } = useSelector(selectUser);
  useEffect(() => {
    if (userToken?.access) {
      dispatch(fetchMyGuysReports({ token: userToken.access }));
    }
  }, [dispatch, userToken]);
  return (
    <div
      style={{
        overflow: "hidden",
        width: "81%",
        margin: "auto",
        marginTop: "50px",
      }}
    >
      <ReportsHeader>
        <div className={"blockTitle"}>My Guys</div> 
      </ReportsHeader>
      <div
        style={{
          display: "flex",
          gap: "1.5rem",
          flexWrap: "wrap",
          justifyContent: "center",
          marginBottom: "50px",
          marginTop: "30px",
        }}
      >
        {myGuysReports?.length > 0 ? myGuysReports?.map((item, index) => (
          <FavouriteReportsCard
            key={index}
            imageUrl={helmetSrc}
            tag={item?.position}
            school={item?.school || "N/A"}
            position={item?.position || "N/A"}
            goals={item?.goals_scored || 0}
            assists={item?.assists || 0}
            minutes={item?.minutes || 0}
            cups={item?.cups || 0}
            playerName={item?.player_name || "N/A"}
            id={item?.id}
          />
        )) : <div style={{textAlign: "center", color: "#888", padding: 32}}>No reports found</div>}
      </div>
    </div>
  );
};

export default MyGuys;
